<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; 2023 <a id="pixinventLink"
      href="https://themeforest.net/user/pixinvent/portfolio?ref=pixinvent">RR Kabel Limited.</a>
    <span class="d-none d-sm-inline-block">, All rights reserved.</span>
  </p>
</footer>
<!--Footer Ends-->
